<template>
  <div>
    <b-navbar toggleable="md" type="light" variant="light">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand>TecknaEl Partneröversikt</b-navbar-brand>

      <b-collapse is-nav id="navCollapse">

        <b-navbar-nav>
          <b-nav-item :to="{name: 'statistics'}">
            Statistik
          </b-nav-item>
          <b-nav-item :to="{name: 'reports'}">
            Sammanställning
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">

          <b-nav-item-dropdown right>
            <template slot="button-content">
              <span>
                <font-awesome-icon icon="user-alt" />
                {{ company.name }}
              </span>
            </template>
            <b-dropdown-item @click="logout">
              Logga ut
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <router-view></router-view>

    <powered-by></powered-by>

  </div>
</template>

<script>

  import {mapState} from 'vuex'
  import PoweredBy from "../Partials/PoweredBy"

  export default {
    name: "Dashboard",
    components: {PoweredBy},
    computed: {
      ...mapState({
        company: state => state.auth.company,
      })
    },
    mounted(){
      if(this.$router.currentRoute.name === 'dashboard'){
        this.$router.push({name: 'statistics'})
      }
    },
    methods: {
      logout(){
        this.$store.commit('login.erase')

        this.$cookies.remove('authToken');

        this.$router.push({name: 'login'});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Index.vue